// extracted by mini-css-extract-plugin
export var $animation_name = "Layout-module--$animation_name--1ebcc";
export var ContentWrapper = "Layout-module--ContentWrapper--32f79";
export var ContentWrapper___visable = "Layout-module--ContentWrapper___visable--4ed6c";
export var Layout = "Layout-module--Layout--8f459";
export var Layout___locked = "Layout-module--Layout___locked--23cdd";